export type BackgroundSelectorProps = {
  translations: Translations;
  onSelectBackground?: (background: BackgroundOption) => void;
};

export type Translations = {
  lightText: string;
  darkText: string;
};

export enum BackgroundOption {
  Light = 'light',
  Dark = 'dark',
}
